import { create as createFedopsLogger } from '@wix/fedops-logger';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { App } from 'components/App/App';

createFedopsLogger('gg-merch-maker-app').appLoaded();

const domNode = document.getElementById('root')!;
const root = createRoot(domNode);

root.render(<App />);
